export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'En',
    'Febr',
    'Mzo',
    'Abr',
    'My',
    'Jun',
    'Jul',
    'Agt',
    'Sept',
    'Oct',
    'Nov',
    'Dic',
  ],
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  months_calendar: {
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
  },
  // weekdays
  weekdays: ['DO', 'L', 'M', 'X', 'J', 'V', 'S'],
  weekdays_booking_container: {
    Sunday: 'Domingo',
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
  },
  weekdays_calendar: {
    Sun: 'Do',
    Mon: 'Lu',
    Tue: 'Ma',
    Wed: 'Mi',
    Thu: 'Ju',
    Fri: 'Vi',
    Sat: 'Sá',
  },
  // additional translations
  today: 'Hoy',
  tomorrow: 'Mañana',
};
